type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: MetaPixelFunction
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

const META_PIXEL_ID = '2243850073137099'
let configured = false
let scriptRequested = false

function createMetaPixelQueue(): MetaPixelFunction {
  if (window.fbq) return window.fbq

  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue.push(args)
    }
  }) as MetaPixelFunction

  fbq.queue = []
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  window.fbq = fbq
  window._fbq = fbq

  return fbq
}

/**
 * Creates Meta's lightweight event queue synchronously, ensuring PageView and
 * very early conversion clicks are retained before the external script loads.
 */
export function prepareMetaPixel(): void {
  if (typeof window === 'undefined' || configured) return

  const fbq = createMetaPixelQueue()
  configured = true
  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
}

/** Downloads the external Meta script after first paint / during idle time. */
export function initializeMetaPixel(): void {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    scriptRequested
  ) {
    return
  }

  prepareMetaPixel()
  scriptRequested = true

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

export function trackAddToCart(value = 10.99): void {
  prepareMetaPixel()
  window.fbq?.('track', 'AddToCart', {
    content_name: 'Método GastroSmart — Acceso Completo + Bonos',
    content_type: 'product',
    currency: 'USD',
    value,
  })
}
